import React from "react";
import ReactDOM from "react-dom";
import "./utils/i18n";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { FormContextProvider } from "./context/formContext";

ReactDOM.render(
  <React.StrictMode>
    <FormContextProvider>
      <App />
    </FormContextProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
